import { ResponseObject } from '#/interfaces';
import request from '#/utils/request';
import useSWR from 'swr';

export interface EthereumBalanceSummaryInfo {
  currentBalance: string;
  effectiveBalance: string;
  validators: number;
}
/**
 * useEthereumBalanceSummary
 */
export default function useEthereumBalanceSummary() {
  return useSWR(
    '/api/v2/eth2/balance/summary',
    url => request.post<ResponseObject<EthereumBalanceSummaryInfo>>(url),
    {
      refreshInterval: 60_000,
      keepPreviousData: true,
    }
  );
}
